<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="700px"
    >
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">{{ collection ? (['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'Arrived' : 'Collected') : (['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'Completed' : 'Returned') }}</span>

          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert
            v-if="['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type)"
            type="info"
            text
            outlined
          >
            Please take at least one image per category of your {{collection ? 'arrival' : 'depature'}}. i.e gate, yard, front of building etc. Do not include customer faces.
          </v-alert>
          <v-alert
            v-else
            type="info"
            text
            outlined
          >
            Please be sure to take as many images as possible for each category of image (Left, Right & Front). You should also include any damage / scratches.
          </v-alert>
          <v-form
            ref="form"
            v-model="validForm"
          >
            <v-row class="mb-8">
              <v-col
                cols="12"
                sm="4"
              >
                <p>{{['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'Image 1' : 'Bike Left'}}</p>
                <FileUpload
                  v-model="bikeLeftFiles"
                  multiple
                  remove-on-upload-success
                  @file:uploaded="file => handleFileUpload(file, `bike_left_files.${action}`)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <p>{{['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'Image 2' : 'Bike Right'}}</p>
                <FileUpload
                  v-model="bikeRightFiles"
                  multiple
                  remove-on-upload-success
                  @file:uploaded="file => handleFileUpload(file, `bike_right_files.${action}`)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <p>{{['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'Image 3' : 'Bike Front'}}</p>
                <FileUpload
                  v-model="bikeFrontFiles"
                  multiple
                  remove-on-upload-success
                  @file:uploaded="file => handleFileUpload(file, `bike_front_files.${action}`)"
                />
              </v-col>
            </v-row>

            <h3
              v-if="files.length > 0"
              class="primary--text"
            >
              Uploaded Files
            </h3>

            <FilesList
              v-if="files.length > 0"
              :files="files"
              hide-file-name
              @file:deleted="getBikeFiles"
            />
          </v-form>
          <FormErrors ref="formErrors" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text x-small @click="closeDialog">Close</v-btn>
          <v-btn color="primary" text small :loading="loading" @click="updateBike">
            {{ collection ? (['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'Arrived' : 'Collected') : 'Returned' }}
            <v-icon small right>mdi-plus-circle-outline</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SnackBar success ref="successBar">
      Bike marked {{ collection ? (['JOB_TYPE_FLEET_ONSITE', 'JOB_TYPE_FLEET_ONSITE_COMPLAINT', 'JOB_TYPE_DOORSTEP', 'JOB_TYPE_COMPLAINT'].includes(bike.job_type) ? 'arrived' : 'collected') : 'returned' }} successfully!
    </SnackBar>
    <SnackBar success ref="fileSuccessBar">
      File uploaded and attached to bike successfully!
    </SnackBar>
    <SnackBar error ref="errorBar">
      There was an issue updating the bikes status.
    </SnackBar>
  </div>
</template>
<script type="text/javascript">
import HasDialog from '@/mixins/HasDialog'
import HasForm from '@/mixins/HasForm'
import HasBike from '@/mixins/HasBike'
import FormErrors from '@/components/FormErrors'
import FileUpload from '@/components/file-upload/FileUpload'
import SnackBar from '@/components/SnackBar'
import FilesList from '@/components/files/FilesList'
import HasFileUpload from '@/mixins/HasFileUpload'

export default {
  name: 'DriverCRSuccessDialog',

  props: {
    collection: {
      type: Boolean,
      required: false,
      default: () => { return false }
    }
  },

  mixins: [ HasDialog, HasForm, HasBike, HasFileUpload ],

  components: {
    FormErrors,
    FileUpload,
    SnackBar,
    FilesList
  },

  watch: {
    dialog: function (dialog) {
      if (dialog) {
        this.getBikeFiles()
      }
    }
  },

  data () {
    return {
      loading: false,
      bikeRightFiles: [],
      bikeLeftFiles: [],
      bikeFrontFiles: []
    }
  },

  computed: {
    loadTypes () {
     return false
    },

    filesRequestParams () {
      return {
        only_types: [
          `bike_left_files.${this.action}`,
          `bike_right_files.${this.action}`,
          `bike_front_files.${this.action}`,
          `bike_back_files.${this.action}`
        ]
      }
    },

    bookingId () {
     return this.bike.booking_id
    },

    updateStatusObject () {
      if (this.collection) {
        return { collection_status: 'STATUS_COLLECTED' }
      }
      return { return_status: 'STATUS_RETURNED' }
    },

    action () {
      if (this.collection) {
        return 'COLLECTION'
      }
      return 'RETURN'
    }
  },

  methods: {
    updateBike () {
      this.loading = true
      this.$api.persist('put', {
        path: `bookings/${this.bike.booking_id}/bikes/${this.bike.id}`,
        object: {
          ...this.updateStatusObject,
          ...{
            job_number: this.bike.ref,
            action: this.action
          }
        }
      })
        .then(() => {
          this.$refs.successBar.open()
          this.error = {}
          this.closeDialog()
        })
        .catch(error => {
          this.$refs.formErrors.setErrors(error)
          this.$refs.errorBar.open()
          this.error = error
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
